// src/components/Adviser/Tabs/LicenseCertificates/LicenseCertificates.jsx

import React from "react";
import { PostCard, Row } from "../../HelperFunctions/HelperFunctions";
import { fmtDate } from "../../../Utils/AdviserFormatters";
import {
  LICENSE_CERTIFICATE_SECTIONS,
  canViewLicenseCertificateField,
} from "../utils/LicenseCertificateFields";
import { useUserPermissions } from "../../../../SignIn/UserPermissionsContext";
import { formatCpdHours } from "../utils/cpdRecords";

export const LicenseCertificates = ({ details, loading }) => {
  const { userPermissions = [] } = useUserPermissions();
  const licenseCertificates = details?.licenseCertificates || {};
  const allCpd = licenseCertificates?.cpd?.all;
  const iddCpd = licenseCertificates?.cpd?.idd;

  const formatFieldValue = (field, value) => {
    if (field.inputType === "booleanRadio") {
      if (value === true) return "Yes";
      if (value === false) return "No";
      return "";
    }

    return field.type === "date" ? fmtDate(value) : value;
  };

  return (
    <div className="smFeed">
      {loading ? (
        <div className="smLoading Content-Small">
          Loading licence certificates…
        </div>
      ) : (
        <>
          {LICENSE_CERTIFICATE_SECTIONS.map((section) => (
            <PostCard key={section.key} title={section.title}>
              <div className="smGrid2">
                {section.fields
                  .filter((field) =>
                    canViewLicenseCertificateField(field, userPermissions),
                  )
                  .map((field) => {
                  const value =
                    licenseCertificates?.[section.key]?.[field.key] ?? "";

                  return (
                    <Row
                      key={`${section.key}-${field.key}`}
                      label={field.label}
                      value={formatFieldValue(field, value)}
                    />
                  );
                  })}
              </div>
            </PostCard>
          ))}
          {allCpd ? (
            <PostCard title="All CPD">
              <div className="smGrid2">
                <Row
                  label="Report Date"
                  value={allCpd.reportDate ? fmtDate(allCpd.reportDate) : ""}
                />
                <Row label="CPD Entries" value={allCpd.cpdEntries ?? 0} />
                <Row
                  label="Total CPD Hours"
                  value={formatCpdHours(allCpd.cpdMinutes)}
                />
                <Row
                  label="Structured Entries"
                  value={allCpd.structuredEntries ?? 0}
                />
                <Row
                  label="Structured Hours"
                  value={formatCpdHours(allCpd.structuredMinutes)}
                />
                <Row
                  label="Non-Structured Entries"
                  value={allCpd.nonStructuredEntries ?? 0}
                />
                <Row
                  label="Non-Structured Hours"
                  value={formatCpdHours(allCpd.nonStructuredMinutes)}
                />
              </div>
            </PostCard>
          ) : null}
          {iddCpd ? (
            <PostCard title="IDD CPD">
              <div className="smGrid2">
                <Row
                  label="Report Date"
                  value={iddCpd.reportDate ? fmtDate(iddCpd.reportDate) : ""}
                />
                <Row label="CPD Entries" value={iddCpd.cpdEntries ?? 0} />
                <Row
                  label="IDD Hours"
                  value={formatCpdHours(iddCpd.cpdMinutes)}
                />
                <Row
                  label="Structured Entries"
                  value={iddCpd.structuredEntries ?? 0}
                />
                <Row
                  label="Structured Hours"
                  value={formatCpdHours(iddCpd.structuredMinutes)}
                />
                <Row
                  label="Non-Structured Entries"
                  value={iddCpd.nonStructuredEntries ?? 0}
                />
                <Row
                  label="Non-Structured Hours"
                  value={formatCpdHours(iddCpd.nonStructuredMinutes)}
                />
              </div>
            </PostCard>
          ) : null}
        </>
      )}
    </div>
  );
};

export default LicenseCertificates;
